interface HoursOperationProps {
    className?: string;
    firstLine?: string;
    secondLine?: string;
    thirdLine?: string;
}

export const HoursOperation = ({
    className,
    firstLine = "Monday - Friday 8 am - 8 pm ET",
    secondLine = "Saturday 11 am - 3 pm ET",
    thirdLine,
}: HoursOperationProps) => {
    return (
        <div data-testid="hours-operation">
            <p className={`text-sm font-bold ${className}`}>Hours of Operation</p>
            <p className={`text-xs font-medium ${className}`}>{firstLine}</p>
            <p className={`text-xs font-medium ${className}`}>{secondLine}</p>
            {thirdLine && <p className={`text-xs font-medium ${className}`}>{thirdLine}</p>}
        </div>
    );
};
